import {
  parseAbsolute,
  parseDate,
  Time,
  toCalendarDateTime,
  toTime,
  toZoned,
  ZonedDateTime,
} from '@internationalized/date';

const shiftStartTime = new Time(7, 0);

export const convertTimeToAbsoluteDateTime = (
  value: Time | ZonedDateTime | null,
  timezone: string,
  apiDate: string,
) => {
  if (!value) return null;

  const time = value instanceof Time ? value : toTime(value);
  const isNextDayTime = time.compare(shiftStartTime) < 0;
  const apiCalendarDate = parseDate(apiDate.split('T')[0]);
  const calendarDate = isNextDayTime ? apiCalendarDate.add({ days: 1 }) : apiCalendarDate;
  const zdt = toZoned(toCalendarDateTime(calendarDate, time), timezone);

  return zdt.toAbsoluteString();
};

export const convertAbsoluteDateTimeToZoned = (value: string | undefined, timezone: string) => {
  if (!value) return null;

  return parseAbsolute(value, timezone);
};
